import * as React from 'react';
export const IcPrimeContent = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M2.93 17.3a3 3 0 003 2.7h12.15a3 3 0 003-2.7l.13-1.3H2.8l.13 1.3zM21.74 7a2 2 0 00-2.09-1 2 2 0 00-1.07.56l-.86.85a1 1 0 01-.32.22 1 1 0 01-.38.07 1 1 0 01-.71-.3l-2.78-2.8a2 2 0 00-2.79 0l-3 2.92a1 1 0 01-.74.26 1 1 0 01-.7-.29l-.9-.9A2 2 0 004.36 6a2 2 0 00-2.11 1A2.07 2.07 0 002 8.2l.6 5.8h18.8l.6-5.8a2.06 2.06 0 00-.26-1.2z'
      fill='currentColor'
    />
  </svg>
);
